// extracted by mini-css-extract-plugin
export default {"Tabs":"frame_Tabs__A5Rsr","TabList":"frame_TabList__0Rh8v","Button":"frame_Button__No8s7"};